// extracted by mini-css-extract-plugin
export var buttonContainer = "_7y-1";
export var fontSizeSelect = "_7y-3";
export var formatSelect = "_7y-2";
export var formats = "_7y-4";
export var hidden = "_7y-5";
export var icon = "_7y-6";
export var select = "_7y-0";